// 联系方式管理
import http from "@/jslibs/axios/http";

// 联系方式列表
export const list = (data) => http.get("/v1/cms/ContactInfo", data);

// 联系方式编辑
export const edit = (data) => http.post(`/v1/cms/ContactInfo`, data);

// 联系方式详情
export const detail = ({ name, ...data }) => http.get(`/v1/cms/ContactInfo/${name}`, data);
